import {match, Pattern} from 'ts-pattern';

import {Nullish} from 'shared/web';

type CountryAdServerName =
  'sauto' | 'autoscout24' | 'otomoto' | 'autobazar_eu' | 'autovit_ro' | 'lacentrale';

/**
 * Returns the country-specific ad server of the target country, `null` when the country has none.
 * mobile.de is offered for every country, so it is not part of this mapping.
 */
export const getCountryAdServerName = (countryCode: string | Nullish) =>
  match(countryCode)
    .returnType<CountryAdServerName | null>()
    .with('CZE', () => 'sauto')
    .with(Pattern.union('DEU', 'ITA', 'AUT', 'BEL', 'NLD'), () => 'autoscout24')
    .with('POL', () => 'otomoto')
    .with('SVK', () => 'autobazar_eu')
    .with('ROU', () => 'autovit_ro')
    .with('FRA', () => 'lacentrale')
    .otherwise(() => null);
